import { defineComponent as _defineComponent } from 'vue'
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  watch,
  ref,
  onMounted,
} from "vue";
import { stateList as states } from "@/core/listas/stateList";
import axios from "axios";
import { useUsuarioStore } from "@/store/usuarioStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'MunicipioUfPerfilDados',
  props: {
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  municipioLabel: {
    type: String,
    default: "Município",
  },
  municipioName: {
    type: Boolean,
    default: false,
  },
  ufLabel: {
    type: String,
    default: "UF",
  },
  isAvailableShow: {
    type: Boolean,
    default: true,
  },
  municipioClass: {
    type: String,
    default: "col-sm-4",
  },
  ufClass: {
    type: String,
    default: "col-sm-2",
  },
  currentUf: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredMunicipio: {
    type: Boolean,
    default: undefined,
  },
  isFilter: {
    type: Boolean,
    default: false,
  },
  disableMod: {
    type: Boolean,
    default: false,
  },
  showMunicipio: {
    type: Boolean,
    default: true,
  },
},
  emits: ["changeUf", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;
const usuarioStore = useUsuarioStore();

const props = __props;

const data = reactive({
  municipios: [] as any,
  uf: "" as any,
  municipio: "" as any,
});

const { municipios, uf, municipio } = toRefs(data);

const municipioSelected = ref({ municipioId: "", municipioNome: "" });

const stateList = computed(() => {
  const ufsPermitidas = usuarioStore.perfilDados?.uf;
  if (ufsPermitidas && ufsPermitidas.length > 0) {
    return states.filter((state) => ufsPermitidas.includes(state.value));
  }
  return states;
});

async function onChangeCarregarMunicipios(event) {
  const uf = event?.target?.value || event;
  emit("changeUf", data.uf);
  if (uf) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_ADMIN_API}/municipio/listagem/${uf}`
      );

      let municipiosList = response.data.dados.map((dado) => ({
        value: dado.id,
        label: dado.nome,
      }));

      const perfilMunicipioId = usuarioStore.perfilDados?.municipioId;
      if (perfilMunicipioId) {
        municipiosList = municipiosList.filter(
          (m) => m.value === perfilMunicipioId
        );
        if (municipiosList.length === 1) {
          data.municipio = perfilMunicipioId;
          emit("update:modelValue", data.municipio);
        }
      }

      data.municipios = municipiosList;
    } catch (error) {
      data.municipios = [];
    }
  }
}

function onChange() {
  return emit("update:modelValue", data.municipio);
}

onMounted(async () => {
  if (props.currentUf) {
    data.uf = props.currentUf;
    onChangeCarregarMunicipios(props.currentUf);
  }

  if (props.modelValue) {
    data.municipio = props.modelValue;
  }
});

watch(
  () => props.currentUf,
  (value) => {
    if (value === "clearfilter") {
      data.uf = null;
      data.municipios = [];
      return;
    }
    if (value) {
      data.uf = value;
      onChangeCarregarMunicipios(value);
    }
  }
);

watch(
  () => props.modelValue,
  (modelValue) => {
    data.municipio = modelValue;
  }
);

watch(
  () => props.isAvailableShow,
  (value) => {
    if (!value) {
      data.municipio = "";
      data.uf = "";
    }
  }
);

watch(
  () => stateList.value,
  (lista) => {
    if (lista.length === 1 && !data.uf) {
      data.uf = lista[0].value;
      onChangeCarregarMunicipios(data.uf);
    }
  },
  { immediate: true }
);

const __returned__ = { emit, usuarioStore, props, data, municipios, uf, municipio, municipioSelected, stateList, onChangeCarregarMunicipios, onChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})